var map = {
	"./apollographql.svg": 7802,
	"./aws.svg": 9353,
	"./db.svg": 2688,
	"./docker.svg": 3458,
	"./dotnet.svg": 6828,
	"./firebase.svg": 5209,
	"./flutter.svg": 4532,
	"./github.svg": 1987,
	"./graphql.svg": 5333,
	"./kotlin.svg": 4673,
	"./nodejs.svg": 1671,
	"./postgresql.svg": 1176,
	"./python.svg": 1684,
	"./react.svg": 6599,
	"./swift.svg": 6135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 606;